import React, { useEffect, useState, useContext, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { GlobalContext } from '../../Contexts/GlobalContext';
import useFetch from 'CustomHooks/useFetch';
import UnpaidOrders__table from './UnpaidOrders__table';
import TextField from '@material-ui/core/TextField';
import useGuiTranslations from '../MultiLanguage/useGuiTranslations';
import { capitalizeFirstLetter } from '../../Util/StringFunctions';


export default function UnpaidOrders(props) {
    const globalContext = useContext(GlobalContext);
    const classes = useStyles();
    const [getOrdersResponse, getOrdersHook] = useFetch();
    const [removeTableResponse, removeTableHook] = useFetch();
    const intervalId = useRef(0);
    const [completedPayments, setCompletedPayments] = useState({});
    const [searchText, setSearchText] = useState('');
    const [translateGui] = useGuiTranslations();

    useEffect(
        () => {
            //window.gtag('config', 'UA-160225157-2', { 'page_path': '/UnpaidOrders' });

            globalContext.dispatchMethod(
                {
                    type: 'SET_MENU_LOCATION',
                    value: {
                        a: 1,
                        b: 109,
                    },
                }
            )

            getOrders();

            return () => {
                //console.log('clearing interval');
            }
        }, []
    )

    const getOrders = () => {
        
        let today= new Date();
        
        let yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        
        getOrdersHook(
            {
                url: "/admin/orders/orders-by-table?PaymentType=PayOnTheTable&PaymentStatus=WaitingForPayment&DateStart="+yesterday.toISOString().slice(0, 10)+"&DateEnd=" + today.toISOString().slice(0, 10),
                addTokenHeader: true,
                method: 'GET',
                postData: null,
                doNotHideMessageBox: true,
            }
        );

    }
    useEffect(
        () => {
            if (getOrdersResponse.tableList) {
                setCompletedPayments({});//resetliyorum her refreshde
                if (intervalId.current == 0) {
                    intervalId.current = setInterval(() => {
                        getOrders();
                    }, 5000);
                }
            }
            console.log(getOrdersResponse);

        }, [getOrdersResponse]
    )

    const addTableToCompletedPayments = (tableId) => {
        setCompletedPayments(
            {
                ...completedPayments,
                [tableId]: true,
            }
        )
        
        removeTable(tableId);

    }

    const removeTable = (tableId) => {

        let tempOrderList = [];
        getOrdersResponse.tableList.map(
            table =>
                table.customerTableId == tableId ?
                    table.purchaseOrderList.map(
                        purchaseOrder =>
                            tempOrderList.push(purchaseOrder.id)
                    )
                    : null
        )

        console.log(tempOrderList);
        
        removeTableHook(
            {
                url: '/admin/orders/set-payment-status',
                addTokenHeader: true,
                method: 'PUT',
                postData: {
                    "orderList": tempOrderList,
                    "paymentStatus": "Completed"
                },
            }
        )
        
    }

    return (
        <div className={classes.root}>
            <TextField value={searchText} onChange={(e)=>setSearchText(e.target.value)} id="standard-basic" label={capitalizeFirstLetter(translateGui(113))} />
            {
                getOrdersResponse.tableList ?
                    getOrdersResponse.tableList.map(
                        table =>
                            completedPayments[table.customerTableId] == undefined  && table.tableNumber.indexOf(searchText)>-1 ?
                                <UnpaidOrders__table
                                    table={table}
                                    addTableToCompletedPayments={addTableToCompletedPayments}
                                ></UnpaidOrders__table>
                                : null

                    )
                    :
                    null
            }
        </div>
    )
}

const useStyles = makeStyles({
    root: {
        '&>div':{
            marginBottom: '20px',
        },
        '&>div:nth-child(1)':{
            marginBottom: '30px',
            marginLeft: '10px',
            width: '300px',
        }
    }
});